import type { RouteLocation } from 'vue-router'
import { getLegacyHandoffResult } from './useLegacyHandoff'
import { restoreSessionOnce } from './useSessionRestoreState'
import { useUrlSetup } from '~/shared/composables/useUrlSetup'

/**
 * Estabelece a sessão no boot: handoff da URL tem prioridade; senão restaura/migra
 * a sessão persistida (bearer → cookie quando aplicável).
 */
export async function useBootstrapSession (route: RouteLocation): Promise<boolean> {
  const pendingHandoff = getLegacyHandoffResult()

  if (pendingHandoff != null) {
    return await pendingHandoff
  }

  const { handoff } = useUrlSetup(route)

  if (handoff != null) {
    return await handoff
  }

  return await restoreSessionOnce()
}
